import React, {Component} from 'react';
import { Field, reduxForm, FieldArray, formValueSelector } from 'redux-form';
import { validate, validatorFromFunction, validators, combine } from 'validate-redux-form';
import { renderField, AsyncSelectField, renderTextArea } from '../../../../Utils/renderField';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import {api} from 'api';
import {RenderCurrency, RenderNumber} from "../../../../Utils/renderField/renderReadField";

class ItemArray extends Component{
    state={
        producto: null,
    }
    setPrecioUnitario = (producto) => {
        const { todos, index } = this.props;
        if(producto !== undefined && producto.cantidad_actual > 0){
            if (producto.es_bodega){
                todos[index]['despachar'] = producto.cantidad_actual;
            }else{
                todos[index]['despachar'] = 0;
            }
        }
    }
    componentDidMount(){
        if( this.props.producto_seleccionado){
            this.setState({producto: this.props.producto_seleccionado.producto});
        }
      }
    componentDidUpdate(prevProps, prevState){
        if(this.props.producto_seleccionado.producto !== prevProps.producto_seleccionado.producto){
            const { todos, index } = this.props;
            if( this.props.producto_seleccionado){
                this.setState({producto: this.props.producto_seleccionado.producto});
            }
        }
    }
    render(){
        const {getProductosOrden, eliminar, index, Despacho, producto_seleccionado, change }= this.props
        const producto = this.state.producto;

        return(
            <tr key={index} style={{height:"68px"}}>
                <td className="text-center sin-borde-top" style={{width: "48px"}}>
                    <img className="action-img" src={require('assets/img/icons/Cerrar.png')} alt="Borrar"
                        title="Borrar"
                        onClick={() =>{
                            eliminar()
                        }}
                    />
                </td>
                <td className="sin-borde-top">
                    <Field
                        label="nombre"
                        name={`${Despacho}.producto`}
                        loadOptions={getProductosOrden}
                        type="text"
                        component={AsyncSelectField}
                        top ={{top:"67px", position:"inherit"}}
                        valueKey="producto__id"
                        labelKey="producto__nombre"
                        onChange={(e) => {
                            this.setState({producto: e});
                        }}
                        className="form-control"
                    />

                </td>

                <td className="sin-borde-top" >
                    {
                        (this.state.producto) ? (
                            // <label><RenderNumber value={this.state.producto.cantidad} /> <span>{this.state.producto.unidad_medida_display}</span></label>
                            <label><RenderNumber value={this.state.producto.total_cantidad} /></label>
                        ) : (
                            <span>--</span>
                        )
                    }
                </td>
                <td className="sin-borde-top" >
                    <Field
                        name={`${Despacho}.a_trasladar`}
                        type="number"
                        // min="0" max="5"
                        component={renderField}
                        top ={{top:"67px", position:"inherit"}}
                        onChange={(e, newValue) => {
                            if (producto && newValue) {
                                const factor = producto.producto__conversion || 1;
                                const volumen = parseFloat(newValue) * factor;

                                change(`${Despacho}.volumen`, volumen);
                            }
                        }}
                    />
                </td>
                <td className="sin-borde-top" >
                    <Field
                        name={`${Despacho}.volumen`}
                        label="volumen"
                        type="number"
                        component={renderField}
                        top={{ top: "95px" }}
                        className="form-control"
                        // disabled={true}
                        onChange={(e, newValue) => {
                            if (producto && newValue) {
                                const cantidad_traslado = parseFloat((newValue / producto.producto__conversion || 1).toFixed(4))
                                change(`${Despacho}.a_trasladar`, cantidad_traslado);
                            }
                        }}
                    />
                </td>
            </tr>
        )
    }
}
const renderProductos = ({fields, meta: {error, submitFailed }, getProductosOrden, todosProductos, change}) => (
        <div className=" col-sm-12 p-0">
            <div className=" col-sm-12 form-group np-r p-0">
                <div className="col-sm-12 form-group np-r  mt-2 sin-borde p-0 color-header-tabla">
                    <table className="table table-sm table-responsive-sm m-0 table-striped">
                        <thead>
                        <tr>
                            <th ></th>
                            <th>Producto</th>
                            <th style={{width: "15%"}}>Existencias</th>
                            <th  style={{width: "15%"}}>a Trasladar</th>
                            <th  style={{width: "15%"}}>Volumen</th>
                        </tr>
                        </thead>
                        <tbody>
                            {fields.map((Despacho, index) => {
                                let todos = fields.getAll()
                                const producto = todosProductos[index];

                                return(
                                    <ItemArray
                                        index={index}
                                        key={index}
                                        producto_seleccionado={producto}
                                        Despacho={Despacho}
                                        todos={todos}
                                        change={change}
                                        getProductosOrden={getProductosOrden}
                                        change={change}
                                        eliminar={ () =>{
                                            fields.remove(index)
                                        }}
                                    />
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-start mt-2">
                    <button type="button" className="btn btn-primary py-0" onClick={() => fields.push({})}>
                        AGREGAR PRODUCTO
                    </button>
                </div>
            </div>
            {submitFailed &&
                    error &&
                    <div className="invalid-feedback-array text-danger">
                            {error}
                    </div>}
        </div>
)
//fin de render de productos


class TrasladoForm extends Component {
    getProductosOrden = (search) => {
        let params = {}
        if(search){
            params.search = search;
        }
        params.bodegaId = this.props.bodega;
        return api.get(`inventario-transicion/get_materia_prima`, params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
    };

    getBodega = (search) => {
        const {item} = this.props;
        return api.get("bodega", { search, empresa: item.empresa}).
        then((data) => {
            if (data) {
                let bodegas = [];
                data.results.forEach(item => {
                    if(item.id != this.props.bodega){
                        bodegas.push(item);
                    }
                });
                return bodegas;
            };
            return [];
        }).catch(() => {
            return [];
        });
    };
    render(){
        const { handleSubmit, orden, bodega, todosProductos, change } = this.props;
        return (
            <form name="TrasladoForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
                <div className="row">

                    {/* <div className="form-group has-feedback col-lg-6 col-md-6 col-12">
                        <label className="t-azul" htmlFor="bodega_destino">Bodega destino*</label>
                        <Field
                                    name={`bodega_destino`}
                                    component={AsyncSelectField}
                                    loadOptions={this.getBodega}
                                    type="text"
                                    filterOptions= {false}
                                    valueKey="id"
                                    labelKey="nombre"
                                    className="form-control"
                                    top ={{top:"67px", position:"inherit"}}
                                />
                    </div> */}
                    <div className="form-group has-feedback col-lg-6 col-md-6 col-12">
                        <label className="t-azul" htmlFor="bodega_destino">Descripción*</label>
                        <Field
                            name={`descripcion`}
                            component={renderTextArea}
                            type="text"
                            className="form-control"
                            top ={{top:"67px", position:"inherit"}}
                        />
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="form-group has-feedback  col-12">
                    <FieldArray
                        name="productosList"
                        component={renderProductos}
                        todosProductos={todosProductos}
                        getProductosOrden={this.getProductosOrden}
                        change={change}
                    />
                    </div>
                </div>
                <br/>
                <div className="row  justify-content-sm-around justify-content-center">
                    <Link className="btn btn-secondary m-1 align-self-center" to={`/estado_bodega/${bodega}`} >CANCELAR</Link>
                    <button type="submit" className="btn btn-primary m-1 align-self-center">GUARDAR</button>
                </div>
            </form>
        );
    }
};


TrasladoForm = reduxForm({
    form: 'TrasladoForm', // a unique identifier for this form
    validate: (data, props) => {
        const errors = {};

        if (!data.descripcion) errors.descripcion = 'Campo requerido.';
        if (data && !data.productosList) errors.productosList = errors.productosList = {_error:'Debe ingresar al menos un producto'};
        if (data && data.productosList && data.productosList.length == 0) errors.productosList = {_error:'Debe ingresar al menos un producto'};

        if (data && data.productosList && data.productosList.length > 0){
            const despachoArray = []
            data.productosList.forEach( (producto, index)=>{
                let detErrors = {};
                let repetidos = [];
                if(producto.producto){
                    repetidos = _.filter(data.productosList, (x) => {
                        if(x.producto)
                            return  x.producto.producto__id == producto.producto.producto__id
                        return false;
                        });
                }

                if(!producto.producto){
                    detErrors.producto =  "Campo requerido";
                }else {
                    if(1 < repetidos.length){
                        detErrors.producto = "Este producto está repetido"
                    }
                }
                if(!producto.a_trasladar){
                    detErrors.a_trasladar = "Campo requerido"
                }else {
                    if(parseFloat(producto.a_trasladar) <= 0){
                        detErrors.a_trasladar = "Debe ser 0 o mayor"
                    }
                    if(parseFloat(producto.a_trasladar) > producto.producto.cantidad){
                        detErrors.a_trasladar = `Debe ser un maximo de ${producto.producto.cantidad}`
                    }
                }
                if(detErrors){
                    despachoArray[index] = detErrors;
                }

            });
            if(despachoArray.length){
                errors.productosList = despachoArray
            }
        }
        return errors
    },
})(TrasladoForm);

const selector = formValueSelector('TrasladoForm');
TrasladoForm = connect(state =>{

    const productos = selector(state, 'productosList')

    let todosProductos = []
    if (productos){
        todosProductos = productos
    }

    return{
        todosProductos
    }
})(TrasladoForm)


export default TrasladoForm;
